// series-7 (C.2 y C.4, #490 y #491, 24-sep-2026): LA TARJETA PADRE DE LAS PARTES DE UN
// DOCUMENTO PARTIDO, EN LA LISTA DEL PANEL.
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos). El nombre del
// archivo no lleva la palabra inglesa de "grupo": el censo de `piloto1.superficies`
// mete en la superficie del profe todo archivo que la lleve.
//
// LA DERIVACION es de `lib/partes.js::agruparPartes` (la padre llega hecha: marca,
// nombre, total, listas, en Pendientes, hijas por numero). Esta pieza solo la pinta.
//
// EL MOLDE es la tarjeta del grupo del profe (#479, `GruposDelAlumno.js`), paso a
// paso: la MISMA pareja movil y escritorio de la tarjeta de documento del Panel, con
// sus cadenas de clases copiadas letra por letra y fijadas por
// `TarjetaPadreDePartes.test.js` contra los fuentes (`TarjetaDeCard.js`, que a su vez
// las fija contra el Panel, y `Dashboard.js` para el bote y su caja de acciones):
//   - la caja del icono con el icono de documento partido (una pila de hojas), del
//     tamano y el color del de documento;
//   - el nombre del documento, a un renglon, recortado como el de un documento;
//   - la linea de informacion: C1 y, si hay partes en Pendientes, " . " + C2, en un
//     renglon con el alto minimo del chip (`ALTO_DEL_CHIP`), asi la plegada mide
//     EXACTAMENTE lo que una tarjeta de documento;
//   - donde la tarjeta de documento lleva su caja de acciones (con el bote), la misma
//     caja: el bote PROPIO de la padre (C9, del tamano del bote del Panel) y, a su
//     derecha, la flecha en el hueco del bote, con `aria-expanded` (C3) y el giro.
// Plegada por omision en cada montaje (el pliegue vive solo en memoria); toda la
// tarjeta abre y cierra; el clic de la flecha y el del bote no suben al cuadro.
//
// ABIERTA: dentro del cuadro, debajo de la cabecera y con la guia vertical
// (`GUIA_DE_LAS_CARDS`), arriba el cuadro "Buscar por nombre" (sin selector: aqui el
// orden es fijo por numero de parte) y debajo las hijas. Cada hija la pinta el Panel
// con `pintarHija(doc, gemela, extra)`: la MISMA tarjeta de documento de hoy (su
// chip, su barra, su bote que borra solo esa parte, su clic para estudiar), una sola
// gemela por gemela de la padre ("movil" o "escritorio"), para no tener cuatro nodos
// por parte ni marcas repetidas. `extra` es el boton "Ver temas" (C4), SOLO en las
// hijas listas o parciales, con 44 de toque en el telefono y 32 en escritorio; abre
// `TemasDeLaParteModal` y, al cerrarla, el foco vuelve a ese boton. Un toque en la
// guia (hijas, buscador, huecos) no pliega la padre. Si lo escrito no deja ninguna
// hija, C14.
//
// #482: con la padre ABIERTA, al posarse o apretar una hija se ilumina solo la hija.
// Mismo arreglo que la tarjeta del grupo: el cuadro de cada gemela lleva la marca
// `data-cuadro-plegable` y la guia `data-guia-plegable`; la regla vive en
// `index.css`. Sin `:has()` (iOS menor a 15.4) queda la conducta de hoy.
//
// EL BOTE abre la confirmacion de la casa (el molde de la ventana de borrar de
// Pendientes: capa fija, panel oscuro, X, titulo, cuerpo, Cancelar y el boton rojo
// con su vuelta mientras corre), con C10 y C11. Los botones reusan los textos de la
// casa: `pending.delete_cancel` ("Cancelar") y `pending.delete_confirm`
// ("Eliminar"); la casa no tiene un "Borrar" suelto. El conteo de C11 es el de TODAS
// las partes de la tarjeta (lo que se va a borrar ademas de las de Pendientes).
// Confirmar llama a `onBorrarTodo(padre)`: el Panel hace la llamada, los avisos
// ("Documento eliminado" / "No se pudo eliminar") y el refresco; mientras corre, el
// boton queda en vuelo, y al terminar (bien o mal) la ventana se cierra. Sin conexion
// (`sinConexion`) el bote queda apagado, como borrar hoy necesita red.
//
// Las dos ventanas van en un portal al `body`: una capa fija dentro de la lista del
// Panel quedaria atada a la tarjeta.
//
// EL TOQUE DE UNA NOTIFICACION (#464; revision adversarial del bloque Panel, hallazgo 3,
// 25-sep-2026): `lib/push.js` busca la marca `doc-<id>` de la parte para ponerla a la
// vista, y plegada esa marca no existe. Antes de cada vistazo avisa con el evento de
// ventana `EVENTO_MOSTRAR_DOC` (`detail.id`); si el id es el de una de SUS hijas, la padre
// se abre, y nada mas (no se pliega, no busca, no desplaza: eso lo hace push.js). Una sola
// cosa mas (revision del remate, hallazgo 2, 25-sep-2026): si lo escrito en su buscador
// esconde esa hija, lo limpia; si no, lo deja.
//
// MARCAS: `partes-<marca>` (gemela de escritorio) y `partes-<marca>-mobile`, y todas
// las demas con el prefijo `partes-`: ni `grupo-` ni `doc-`, que barren otras pruebas.
//
// ── dashboard-rediseno (15-oct-2026): "DOCUMENTO DIVIDIDO PLEGABLE" (4.6 y bloque B) ──────────
// LAPIDA de lo de arriba: el molde ya no es la pareja de dos renglones de la tarjeta del grupo,
// ni el bote propio ni la flecha en su hueco. Lo de hoy:
//   - CERRADA: una tarjeta del MISMO tamano que la de un documento (el cascaron de anatomia fija
//     de `components/panel/`), con el efecto apilado (`APILADA`), el icono de capas, el nombre,
//     el menu de tres puntos (Rename y Delete SIEMPRE, terminen o no sus partes: Rename cambia el
//     nombre del grupo y Delete abre la confirmacion de borrar todas), el renglon "PDF, 3 of 3
//     parts ready" y abajo "282 questions, 349 flashcards" o, con partes en Pendientes, "1 in
//     Pending" en naranja (B2); en el pie, "Show 3 parts" a la derecha (en el telefono, a lo
//     ancho). Su celda es una de la rejilla.
//   - ABIERTA: ocupa toda la fila (`A_LO_ANCHO`) y se quita el efecto apilado; "Hide parts" va
//     en el encabezado, antes del menu (en el telefono, debajo del nombre y a lo ancho); debajo,
//     una linea, el buscador de hoy a lo ancho y las partes en su rejilla (3, 2 o 1 columnas),
//     cada una con la tarjeta de documento interna del Panel ("Part n of N", su menu "Delete
//     part"). Con partes en Pendientes, al final UNA franja naranja de 44 px "N parts pending.
//     Continue ->" que lleva a Pendientes (B2, una vez por padre: la de cada parte se fue).
//   - B5: la confirmacion de borrar con el estilo de ventana de la seccion H.
// El buscador, el evento de push y el borrado conservan su conducta. Las marcas de #482 se quedan:
// el cuadro de cada gemela lleva el radio de la tarjeta, asi el reposo que le pone `index.css`
// queda detras de la tarjeta (opaca y del mismo radio) y no asoma por las esquinas.
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronDown, Layers, ListChecks, Loader2, Pencil, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import BuscadorEnTarjeta from './BuscadorEnTarjeta';
import TemasDeLaParteModal, { VER_TEMAS_MOVIL, VER_TEMAS_ESCRITORIO } from './TemasDeLaParteModal';
import { filtrarPorNombre } from '../lib/buscarPorNombre';
import { filtrarPorNombreOTema, resumenDeTemas, useTemasParaBuscar, idsPedibles } from '../lib/buscarPorTema';
import { EVENTO_MOSTRAR_DOC } from '../lib/push';
import CascaronDeTarjeta from './panel/CascaronDeTarjeta';
import MenuDeTresPuntos from './panel/MenuDeTresPuntos';
import VentanaDelPanel, { BOTON_VENTANA_SECUNDARIO, BOTON_VENTANA_BORRAR } from './panel/VentanaDelPanel';
import {
  A_LO_ANCHO, REJILLA_INTERNA, RENGLON, BOTON_PIE_SECUNDARIO, TRAZO_ICONO, ZONA_ENCABEZADO, ZONA_DETALLE, TARJETA,
  CAJA_ICONO, TITULO, nombreConCortes, ICONO_VER_TEMAS,
} from './panel/anatomia';
import { claveDelTipo, nombreDelTipo, conteosDe, SEPARADOR_DEL_RENGLON, renglonConEstilo } from './panel/tipoDelDocumento';
// estilos-1 (4.4): el padre lleva a la vista el examen que heredan sus partes ("NCLEX, 3 of 3 parts ready").
import { useEstilos, nombreCortoDelDocumento } from '../lib/estilos';

// ajustes-1-3-0 (Bloque C8, ajuste 18, solo app): sin conexion, una opcion apagada avisa con el
// texto de hoy de "necesitas conexion"; un `id` fijo para que tres toques sean un banner.
export const AVISO_SIN_CONEXION_ID = 'sin-conexion-borrar';
// LAPIDA dashboard-rediseno: el bote y la caja de acciones de cada gemela se fueron (el borrado
// vive en el menu de tres puntos). Las constantes se quedan exportadas para quien las leia.
export const BOTE_MOVIL = 'text-[#6a6a6a] hoverable:text-red-400 active:bg-accent active:text-red-400 active:duration-0 min-h-[44px] min-w-[44px] h-10 w-10 p-0';
export const BOTE_ESCRITORIO = 'text-[#6a6a6a] hoverable:text-red-400 active:bg-accent active:text-red-400 active:duration-0 h-8 w-8 p-0';
export const ACCIONES_MOVIL = 'flex items-center gap-1 shrink-0';
export const ACCIONES_ESCRITORIO = 'flex items-center gap-2 shrink-0';
export { VER_TEMAS_MOVIL, VER_TEMAS_ESCRITORIO };
// El efecto apilado del padre cerrado (documento de diseno, "Documento dividido plegable").
export const APILADA = '0 7px 0 -3px #1E1E1E, 0 14px 0 -6px #171717';

const CON_TEMAS = new Set(['ready', 'partial']);

// Un clic que se queda donde nacio (no sube al cuadro de la padre).
const quieto = (e) => e.stopPropagation();
const nombreDeHija = (doc) => doc.filename;

// ajustes-1-3-0 (Bloque C3, #501): `pedirTemas(ids) -> Promise<{id: [nombres]}>` es la puerta
// a GET /api/documents/temas; la tarjeta la llama UNA vez, en la primera tecla. (Bloque C8)
// `enApp`: en la app, sin conexion, las opciones del menu se ven apagadas y avisan al tocarlas;
// en la web Delete sigue `disabled` sin conexion, como hoy. dashboard-rediseno: `onRenombrar`
// abre la ventana de Rename del Panel con el nombre de la padre; `alIrAPendientes` es la franja
// de B2. Cuarta vuelta: `menuApagado` es el arranque de la app (A18, "menu apagado hasta saber el
// estado"): el padre tambien se pinta en ese instante, asi que su menu va apagado como el de cada
// tarjeta.
export default function TarjetaPadreDePartes({
  padre, t, pintarHija, onBorrarTodo, sinConexion = false, userId, pedirTemas = null, enApp = false,
  onRenombrar = null, alIrAPendientes = null, pendientesDelGrupo = 0, menuApagado = false,
}) {
  const [abierta, setAbierta] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const estilos = useEstilos();
  const [temasDe, setTemasDe] = useState(null);
  const [confirmando, setConfirmando] = useState(false);
  const [borrando, setBorrando] = useState(false);
  const volverA = useRef(null);
  const volverAlMenu = useRef(null);

  const marca = padre.marca;
  const hijas = Array.isArray(padre.hijas) ? padre.hijas : [];
  const idsConTemas = idsPedibles(hijas.filter((h) => h && CON_TEMAS.has(h.status)));
  const temasDeBusqueda = useTemasParaBuscar(idsConTemas, busqueda, pedirTemas);
  const temasListos = typeof pedirTemas !== 'function' || idsConTemas.length === 0 || temasDeBusqueda.temas !== null;
  const ayudaDelCuadro = temasDeBusqueda.cargando
    ? t('dashboard:tarjeta_plegable.buscando_temas')
    : temasDeBusqueda.fallo ? t('dashboard:tarjeta_plegable.temas_fallo') : null;
  const hijasRef = useRef(hijas);
  hijasRef.current = hijas;

  // #464: el toque de una notificacion abre la padre de la hija pedida (sin cambio).
  useEffect(() => {
    const alPedirse = (e) => {
      const id = e && e.detail && typeof e.detail === 'object' ? e.detail.id : null;
      if (!id) return;
      const hija = hijasRef.current.find((h) => h && h.id === id);
      if (!hija) return;
      setAbierta(true);
      setBusqueda((escrito) => (filtrarPorNombre([hija], escrito, nombreDeHija).length ? escrito : ''));
    };
    window.addEventListener(EVENTO_MOSTRAR_DOC, alPedirse);
    return () => window.removeEventListener(EVENTO_MOSTRAR_DOC, alPedirse);
  }, []);
  // t7-2a (F1): al PLEGAR, el cuadro se vacia.
  const alternar = () => {
    if (abierta) setBusqueda('');
    setAbierta(!abierta);
  };
  const visibles = filtrarPorNombreOTema(hijas, busqueda, nombreDeHija, temasDeBusqueda.temasDe);

  // El renglon 1: el tipo y cuantas partes estan listas; el 2: lo que generaron, o B2.
  const tipo = nombreDelTipo(claveDelTipo(hijas[0] || {}), t);
  const cortoDelEstilo = nombreCortoDelDocumento(estilos, hijas.find((h) => h && h.estilo) || null);
  const linea = cortoDelEstilo
    ? renglonConEstilo(cortoDelEstilo, [t('dashboard:partes_padre.listas', { ready: padre.ready, total: padre.total })])
    : `${tipo}${SEPARADOR_DEL_RENGLON}${t('dashboard:partes_padre.listas', { ready: padre.ready, total: padre.total })}`;
  const listas = hijas.filter((h) => h && CON_TEMAS.has(h.status));
  const preguntas = listas.reduce((n, h) => n + (h.question_count || 0), 0);
  const flashcards = listas.reduce((n, h) => n + (h.flashcard_count || 0), 0);
  const conPendientes = padre.pendingCount > 0;

  const cerrarTemas = useCallback(() => setTemasDe(null), []);
  const abrirTemas = (doc, boton) => {
    volverA.current = boton;
    setTemasDe(doc);
  };

  const borrarTodo = async () => {
    if (borrando) return;
    setBorrando(true);
    try {
      if (onBorrarTodo) await onBorrarTodo(padre);
    } catch (e) {
      // El Panel pinta el aviso de fallo; aqui solo se cierra la ventana.
    } finally {
      setBorrando(false);
      setConfirmando(false);
    }
  };
  const cerrarConfirmacion = useCallback(() => setConfirmando(false), []);

  // "View topics" de una hija (solo listas o parciales), en el pie de su tarjeta.
  const verTemas = (doc, gemela) => {
    if (!CON_TEMAS.has(doc.status)) return null;
    const movil = gemela === 'movil';
    return (
      <button type="button"
        onClick={(e) => { quieto(e); abrirTemas(doc, e.currentTarget); }}
        className={BOTON_PIE_SECUNDARIO}
        data-testid={`partes-ver-temas-${doc.id}${movil ? '-mobile' : ''}`}>
        <ListChecks className={ICONO_VER_TEMAS} aria-hidden="true" />
        {t('dashboard:partes_padre.ver_temas')}
      </button>
    );
  };

  const avisarSinRed = () => toast.error(t('common:offline.need_connection'), { id: AVISO_SIN_CONEXION_ID });
  const menu = (sufijo) => (
    <MenuDeTresPuntos testid={`menu-partes-${marca}${sufijo}`} etiqueta={t('dashboard:panel.opciones_documento')}
      tactil={sufijo === '-mobile'} sinRed={sinConexion && enApp} alSinRed={avisarSinRed} apagado={menuApagado}
      opciones={[
        {
          testid: `renombrar-partes-${marca}${sufijo}`, texto: t('dashboard:panel.renombrar'), icono: Pencil,
          alTocar: (ref) => { volverAlMenu.current = ref ? ref.current : null; if (onRenombrar) onRenombrar(padre, ref); },
        },
        {
          testid: `partes-${marca}-borrar${sufijo}`, texto: t('dashboard:pending.delete_confirm'), icono: Trash2, peligro: true,
          separadorAntes: true, apagado: sinConexion && !enApp,
          alTocar: (ref) => { volverAlMenu.current = ref ? ref.current : null; setConfirmando(true); },
        },
      ]} />
  );
  const botonPartes = (sufijo, ancho) => (
    <button type="button" onClick={(e) => { quieto(e); alternar(); }} aria-expanded={abierta}
      className={`${BOTON_PIE_SECUNDARIO}${ancho ? ' w-full' : ''}`}
      data-testid={`partes-${marca}-toggle${sufijo}`}>
      {abierta ? t('dashboard:panel.ocultar_partes') : t('dashboard:panel.ver_partes', { count: hijas.length })}
      <ChevronDown className={`w-4 h-4 transition-transform ${abierta ? 'rotate-180' : ''}`} aria-hidden="true" />
    </button>
  );
  const detalle = (sufijo) => (
    <>
      <p className={RENGLON} data-testid={`partes-${marca}-linea${sufijo}`}>{linea}</p>
      {conPendientes ? (
        <p className={`${RENGLON} text-[#F7A06A] font-semibold`} data-testid={`partes-${marca}-pendientes-linea${sufijo}`}>
          {t('dashboard:partes_padre.en_pendientes', { pending: padre.pendingCount })}
        </p>
      ) : (
        <p className={RENGLON}>{conteosDe(preguntas, flashcards, t).join(SEPARADOR_DEL_RENGLON)}</p>
      )}
    </>
  );
  const nombre = (sufijo) => <span data-testid={`partes-${marca}-nombre${sufijo}`}>{nombreConCortes(padre.nombre)}</span>;

  // Las hijas de adentro, cada gemela con su gemela; arriba, el buscador; al final, B2.
  const adentro = (gemela, sufijo) => (
    <div className="mt-4 pt-4 border-t border-[#222222]" onClick={quieto} data-guia-plegable="" data-testid={`partes-${marca}-hijas${sufijo}`}>
      <BuscadorEnTarjeta t={t} valor={busqueda} alCambiar={setBusqueda} testid={`partes-${marca}-buscar${sufijo}`}
        ayuda={ayudaDelCuadro} alto={44} tocable44 />
      <div className="mt-3">
        {visibles.length === 0 ? (temasListos ? (
          <p className="text-[13px] text-[#9A9A9A] leading-snug py-2" data-testid={`partes-${marca}-nada${sufijo}`}>
            {t('dashboard:tarjeta_plegable.nada_coincide')}
          </p>
        ) : null) : (
          <div className={REJILLA_INTERNA}>
            {visibles.map(({ item: doc, temas }) => (
              <React.Fragment key={doc.id}>
                {pintarHija(doc, gemela, verTemas(doc, gemela), temas ? resumenDeTemas(temas) : null, temas ? temas.length : 0)}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
      {/* La franja sale de la MISMA fuente que la franja de antes de cada parte: el resumen de
          Pendientes del grupo (`pendientesDelGrupo`, que el Panel lee de `pendingByParent`). */}
      {pendientesDelGrupo > 0 ? (
        <button type="button" onClick={(e) => { quieto(e); if (alIrAPendientes) alIrAPendientes(marca); }}
          className="mt-3 w-full h-11 px-4 rounded-xl bg-[#241710] border border-[#3A2414] text-[#F7A06A] text-[14px] font-semibold flex items-center justify-center gap-1.5"
          data-testid={`partes-${marca}-pendientes${sufijo}`}>
          {t('dashboard:library_pending', { count: pendientesDelGrupo })}
        </button>
      ) : null}
    </div>
  );

  const icono = <Layers className={TRAZO_ICONO} aria-hidden="true" />;
  const cerrada = (sufijo) => (
    <CascaronDeTarjeta id={`partes-${marca}`} sufijo={sufijo} estado={conPendientes ? 'B2' : 'B1'}
      icono={icono} titulo={nombre(sufijo)} tituloTitle={padre.nombre} menu={menu(sufijo)}
      detalle={detalle(sufijo)}
      pie={(
        <>
          <div className="hidden md:block flex-1" aria-hidden="true" />
          {botonPartes(sufijo, sufijo === '-mobile')}
        </>
      )}
      className="cursor-pointer" style={{ boxShadow: APILADA }}
      onClick={alternar} />
  );
  const abiertaTarjeta = (sufijo) => (
    <div className={`${TARJETA} cursor-default`} data-testid={`tarjeta-partes-${marca}${sufijo}`} data-estado="B1">
      <div className={ZONA_ENCABEZADO} onClick={alternar}>
        <div className={CAJA_ICONO} aria-hidden="true">{icono}</div>
        <p className={TITULO} title={padre.nombre}>{nombre(sufijo)}</p>
        {sufijo === '' ? botonPartes(sufijo, false) : null}
        {menu(sufijo)}
      </div>
      <div className={ZONA_DETALLE}>{detalle(sufijo)}</div>
      {sufijo === '-mobile' ? botonPartes(sufijo, true) : null}
      {adentro(sufijo === '-mobile' ? 'movil' : 'escritorio', sufijo)}
    </div>
  );

  const cuerpoDeConfirmacion = padre.pendingCount > 0
    ? t('dashboard:partes_padre.borrar_cuerpo', { count: hijas.length, pending: padre.pendingCount })
    : t('dashboard:partes_padre.borrar_cuerpo_sin_pendientes', { count: hijas.length });

  return (
    <div className={abierta ? A_LO_ANCHO : ''} data-celda={`p:${marca}`}>
      <div className="md:hidden rounded-[18px]" data-cuadro-plegable="" data-testid={`partes-${marca}-mobile`}>
        {abierta ? abiertaTarjeta('-mobile') : cerrada('-mobile')}
      </div>
      <div className="hidden md:block rounded-[18px]" data-cuadro-plegable="" data-testid={`partes-${marca}`}>
        {abierta ? abiertaTarjeta('') : cerrada('')}
      </div>

      {/* La ventana de temas nace al tocar "View topics" y muere al cerrarla. */}
      {temasDe && (
        <TemasDeLaParteModal open onClose={cerrarTemas} documento={temasDe} userId={userId} t={t} volverA={volverA} />
      )}

      {/* B5: la confirmacion de borrar la padre, con el estilo de ventana de la seccion H. */}
      {confirmando && (
        <VentanaDelPanel titulo={<span data-testid={`partes-${marca}-confirmar-titulo`}>{t('dashboard:partes_padre.borrar_titulo', { name: padre.nombre })}</span>}
          alCerrar={cerrarConfirmacion} volverA={volverAlMenu.current ? { current: volverAlMenu.current } : null}
          testid={`partes-${marca}-confirmar`} etiquetaId={`partes-${marca}-confirmar-etiqueta`}
          botones={(
            <>
              <button type="button" onClick={cerrarConfirmacion} className={BOTON_VENTANA_SECUNDARIO} data-testid={`partes-${marca}-confirmar-cancelar`}>
                {t('dashboard:pending.delete_cancel')}
              </button>
              <button type="button" onClick={borrarTodo} disabled={borrando} className={BOTON_VENTANA_BORRAR} data-testid={`partes-${marca}-confirmar-btn`}>
                {borrando && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}
                {t('dashboard:pending.delete_confirm')}
              </button>
            </>
          )}>
          <p className="text-[14px] leading-5 text-[#9A9A9A]" data-testid={`partes-${marca}-confirmar-cuerpo`}>{cuerpoDeConfirmacion}</p>
        </VentanaDelPanel>
      )}
    </div>
  );
}
